import { Button, Card, Flex, Heading, HelpIcon } from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { ICondition, IConditionGroup, QueryLogicalOperator } from 'common/interfaces/query';
import { useTranslation } from 'react-i18next';
import { QueryLogicalOperatorSelect } from './query-logical-operator-select';
import { QueryRow } from './query-query-row';

interface IQueryConditionGroupProps {
  conditionGroup: IConditionGroup;
  updateCondition: (conditionIndex: number, changes: Partial<ICondition>) => void;
  handleDeleteCondition: (conditionIndex: number) => void;
  handleAddCondition: () => void;
  setOperator: (operator: QueryLogicalOperator) => void;
}

export const QueryConditionGroup = (
  {
    conditionGroup,
    updateCondition,
    handleDeleteCondition,
    handleAddCondition,
    setOperator,
  }: IQueryConditionGroupProps,
) => {
  const { t } = useTranslation();

  const tooltipMessage = conditionGroup.operator === QueryLogicalOperator.And
    ? t(translations.query_andGroupTooltip)
    : t(translations.query_orGroupTooltip);

  return (
    <Card
      bordered
      heading={
        <Flex alignItems="center" gap="var(--padding-xs)">
          <Heading>
            {t(translations.query_conditionGroup)}s
          </Heading>
          <QueryLogicalOperatorSelect value={conditionGroup.operator} onChange={setOperator} />
          <HelpIcon text={tooltipMessage} />
        </Flex>

      }
      padding>
      <QueryRow
        conditions={conditionGroup.conditions}
        updateCondition={updateCondition}
        handleDeleteCondition={handleDeleteCondition}
      />
      <Button
        label={t(translations.query_addCondition)}
        icon="add"
        onClick={handleAddCondition}
      />
    </Card>
  );
};
